import * as Sentry from "@sentry/nuxt";

const config = useRuntimeConfig();
const dsn = config.public.sentry?.dsn;

// DSN is injected via the platform ConfigMap in deployed environments; empty locally = Sentry off.
if (dsn) {
  Sentry.init({
    dsn,
    environment: config.public.sentry?.environment || "production",
    tracesSampleRate: 0.1,
    beforeSend(event) {
      const message = event.exception?.values?.[0]?.value;
      if (
        message &&
        (message.includes("chrome-extension://") ||
          message.includes("moz-extension://") ||
          message.includes("ResizeObserver"))
      ) {
        return null;
      }
      return event;
    },
  });

  Sentry.setTag("module", "frontend-dss-nuxt");
}
